import React, { Component, Fragment } from "react";

import moment from "moment";
import { Icon } from "components";

class Log extends Component {
  state = {
    open: false,
  };

  handleToggle = () => {
    const { open } = this.state;

    this.setState({ open: !open });
  };

  render() {
    const { open } = this.state;
    const { data } = this.props;

    return (
      <Fragment>
        <tr>
          <td className="auditable-type">
            <b>{data.attributes.auditable_type}</b>
            <small>{data.attributes.auditable_id}</small>
          </td>
          <td>{data.attributes.action}</td>
          <td>{data.attributes.version}</td>
          <td>{(data.attributes.user && data.attributes.user.name) || '-'}</td>
          <td>{data.attributes.remote_address}</td>
          <td>
            {moment(data.attributes.created_at).format("DD/MM/YYYY [às] HH:mm")}
          </td>

          <td className="text-right">
            <button className="button-icon" onClick={this.handleToggle}>
              {open ? (
                <Icon name="minus" prefix="fa" />
              ) : (
                <Icon name="plus" prefix="fa" />
              )}
            </button>
          </td>
        </tr>
        {open && (
          <tr>
            <td colSpan="7" className="code-highlighter">
              <pre>
                {JSON.stringify(data.attributes.audited_changes, null, 4)}
              </pre>
            </td>
          </tr>
        )}
      </Fragment>
    );
  }
}

export default Log;
